"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var HaikuReactDOMAdapter_1 = require("./HaikuReactDOMAdapter");
exports.default = HaikuReactDOMAdapter_1.default;
//# sourceMappingURL=index.js.map